import React, { Component } from 'react';
import { isEmpty } from "lodash";
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import AddCircleIcon from "@mui/icons-material/AddCircle";
import PostForm from './PostForm';
import { Edit, CloudDownloadRounded, AddCircleOutlineRounded, DeleteRounded } from '@mui/icons-material';
import { IconButton, Grid, Box } from '@mui/material';
import PostSingle from './PostSingle';
import SearchBar from '../../common/SearchBar';
import DeleteDialog from '../../common/DeleteDialog';

class PostsList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        openForm: false,
        openUpdate: false,
        openDetails: false,
        selected: {},
        selectedPost: {},
        searchValue: "",
    }

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentDidMount() {
        window.scrollTo(0, 0);
        // if(isEmpty(this.props.POSTS)){
        //     this.props.fetchPosts()
        // }
    }

    handleClose = () => {
		this.setState({ 
            openForm: false,
            openUpdate: false,
            openDetails: false,
            selected: {},
            selectedPost: {},
        });
    };    

    getPostsList = () => {
        const { rowsPerPage, page, searchValue } = this.state;
        const { POSTS } = this.props;
        if (!isEmpty(POSTS)){
            let list = Object.values(POSTS)
            if( !isEmpty(searchValue) ){
                list = list.filter( post => post.post_name.toLowerCase().includes(searchValue) );
            }

            // return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item =>
            return list.map(item => (
                <TableRow hover key={item.post_id} className="">
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedPost: item})}
                    >
                        {item.post_name}
                    </TableCell>                                                   
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedPost: item})}
                    >
                        {item.post_require_project ? "Oui" : "Non"}
                    </TableCell>                                                   
                    <TableCell
                        onClick={ () => this.setState({ openDetails: true, selectedPost: item})}
                    >
                        {item.post_require_chantier ? "Oui": "Non"}
                    </TableCell>                                                   
                                                                     
                    <TableCell>
                        <IconButton 
                            size="small" 
                            onClick={ () => this.setState({openUpdate: true, selected: item}) }
                        >
                            <Edit />
                        </IconButton>    
                        <IconButton 
                            size="small" 
                            onClick={ () => this.setState({openDelete: true, selected: item}) }
                        >
                            <DeleteRounded />
                        </IconButton>    
                    </TableCell>                                                   
                </TableRow>
            ) )
        }
    }

    handleChange = (e) => {
        const { value } = e.target;

        this.setState({
            "searchValue": value.toLowerCase()
        })
    }

    handleDelete = async () => {
        const { selected } = this.state;
        await this.props.deletePost(selected)
        if(this.props.STATE.post.error){
            // this.props.notif("error", "ERROR")
            this.props.notif("error", this.props.STATE.post.error)
        } else {
            
            this.props.notif("success", "poste supprimé")
            this.setState({
                openDelete: false,
                selected: {},
            })
        }
    }

    render() {
        const { openForm, rowsPerPage, page, openUpdate, openDelete, selected, openDetails, selectedPost } = this.state;
        const { POSTS } = this.props;
        return (
            <div>
                {openForm &&
                    <PostForm open={openForm} handleClose={this.handleClose} {...this.props} />
                }
                {openUpdate && !isEmpty(selected) &&
                    <PostForm 
                        update 
                        post={selected} 
                        open={openUpdate} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openUpdate && !isEmpty(selected) &&
                    <PostForm 
                        update 
                        post={selected} 
                        open={openUpdate} 
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openDetails && !isEmpty(selectedPost) &&
                    <PostSingle
                        open={openDetails} 
                        post={selectedPost}
                        handleClose={this.handleClose} 
                        {...this.props} 
                    />
                }
                {openDelete && !isEmpty(selected) &&
                    <DeleteDialog
                        title={"le poste"}
                        open={true}
                        close={() => this.setState({ openDelete: false, selected: {} })}
                        {...this.props}
                        handleSubmit={this.handleDelete}
                    />
                }
                <Box style={{ display:"flex", justifyContent:"space-between", alignItems: "center"}}>
                    <SearchBar 
                        handleChange={this.handleChange} 
                        label="Rechercher"
                        searchValue={this.state.searchValue}
                    />
                    <Button 
                        variant="contained" 
                        color="secondary" 
                        onClick={() => this.setState({ openForm: true })} 
                        title="Nouveau Poste"
                        startIcon={<AddCircleOutlineRounded />}
                    >
                        Ajouter
                    </Button>
                    {/* <IconButton color="primary" onClick={ () => this.props.handleDownload("/extract/posts", "MJB_posts.csv") } disabled={this.props.downloading}>
                        <CloudDownloadRounded />
                    </IconButton> */}
                </Box>

                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Nom</TableCell>
                            <TableCell>Projet</TableCell>
                            <TableCell>Chantier</TableCell>
                            <TableCell>Modifier</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.getPostsList()}
                    </TableBody>
                    {/* {size(POSTS) > 10 &&
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[10, 15]}
                                    colSpan={2}
                                    count={size(POSTS)}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    SelectProps={{
                                        native: true,
                                    }}
                                    onPageChange={this.handleChangePage}
                                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                                    ActionsComponent={Pagination}
                                />
                            </TableRow>
                        </TableFooter>
                    } */}
                </Table> 
            </div>
        );
    }
}

export default PostsList;